<div class="px-2" *ngIf="!isOpened">
  <app-custom-table [showRecover]="true" [headers]="constructionSiteHeader" [data]="constructionSiteData"
    [showCheckbox]="true" [checkBoxAction]="checkboxActions" [previousFilters]="filters" [filterPersistentKey]="url"
    [clearSelectionTrigger]="clearSelection"
    (onRecoverData)="getConstructionSitesForSelection()" (onPageChange)="onPageChange($event)"
    (onFilterChange)="onFilterChange($event)" (onAction)="onAction($event)">
  </app-custom-table>
  <app-custom-modal #errorsModal [label]="'Errores'" [width]="'40rem'"
    [header]="'Errores al Inactivar'" [children]="componentErrorsModal"
    [inputs$]="inputsForErrorsModal$" hidden>
  </app-custom-modal>
</div>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>